export default __webpack_public_path__ + "static/media/chassis.30d303db.svg";